export default __webpack_public_path__ + "static/media/rco.794353ed.png";